import { render, staticRenderFns } from "./wacth.vue?vue&type=template&id=84558c1c"
import script from "./wacth.vue?vue&type=script&lang=js"
export * from "./wacth.vue?vue&type=script&lang=js"
import style0 from "./wacth.vue?vue&type=style&index=0&id=84558c1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports